var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0509 3.27236C18.2657 3.05757 18.2657 2.70933 18.0509 2.49454L15.7174 0.161091C15.5027 -0.053697 15.1544 -0.0536974 14.9396 0.161091L9.10612 5.99459L3.27305 0.161522C3.05826 -0.0532668 2.71002 -0.0532667 2.49523 0.161522L0.161777 2.49497C-0.0530113 2.70976 -0.0530116 3.058 0.161777 3.27279L5.99485 9.10586L0.161091 14.9396C-0.0536969 15.1544 -0.0536968 15.5027 0.161092 15.7174L2.49454 18.0509C2.70933 18.2657 3.05757 18.2657 3.27236 18.0509L9.10612 12.2171L14.9403 18.0513C15.1551 18.2661 15.5033 18.2661 15.7181 18.0513L18.0516 15.7179C18.2664 15.5031 18.2664 15.1548 18.0516 14.9401L12.2174 9.10586L18.0509 3.27236Z",
    fill: "#E9E9E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.ed66534e96aa1ab911df17ae7dd041df.svg";
export { ForwardRef as ReactComponent };